import { createContext, useContext } from "react";
/**
 * Context that provides access to the Dialog's DOM element.
 *
 * This is used by child components that need to render portals or poppers
 * within the dialog's stacking context. Without this, elements like tooltips
 * would render outside the dialog and have z-index/positioning issues.
 *
 * @example
 * // Consuming the context (automatically done by Tooltip component)
 * const containerRef = useDialogContainer();
 * <Popper container={containerRef?.current} />
 */
export var DialogContainerContext = createContext(null);
/**
 * Hook to access the nearest Dialog's container element.
 * Returns null when not inside a Dialog.
 *
 * Note: The Tooltip component automatically uses this hook to render
 * its Popper within the dialog's stacking context.
 */
export var useDialogContainer = function () { return useContext(DialogContainerContext); };
